import { IRootState } from "../../../redux/root.reducer";
import { createIGSERedux } from "../../../shared/igse-redux/igse-redux-factory";
import { selectAuthTokens } from "../../auth/selectors/auth.selector";
import { getStates } from "../service/states.api";

const {
    actions: statesActions,
    reducer: statesReducer,
    epic: statesEpic,
} = createIGSERedux<Array<string>>({
    actionNames: {
        init: "STATES_INIT",
        get: "STATES_GET",
        success: "STATES_SUCCESS",
        error: "STATES_ERROR",
    },
    fetcher: () => getStates(selectAuthTokens()),
    selector: (state: IRootState) => state.states,
});

export { statesActions, statesReducer, statesEpic };
